import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { DatatableRowsExpanderModel } from '../../models/datatable/datatable-rows-expander.model';
import { DatatableRowsExpanderStylingModel } from '../../models/datatable/datatable-rows-expander-styling.model';
import { DatatableRowsExpanderTemplates } from '../../templates/datatable-rows-expander.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CfDatatableRowsExpander component is used to expand/collapse all rows</p>
 * <pre>
 * <code>
 * <code><</code>cf-datatable-rows-expander<code>></code><code><</code><code>/</code>cf-datatable-rows-expander<code>></code>
 * </code>
 * </pre>
 */
export class CfDatatableRowsExpanderComponent extends CfCoreComponent implements OnInit {
/**
 * <pre>{{'{'}}
 *  expandAllIcon: IconModel,
 *  collapseAllIcon: IconModel,
 * {{'}'}}</pre>
 * <h4>expandAllIcon: IconModel</h4>
 * CfIcon component for the main expanding icon.
 * <h4>collapseAllIcon: IconModel</h4>
 * CfIcon component for the main collapsing icon.
 * <p>Example:</p>
 * <pre>{{'{'}}
 *    expandAllIcon: this.myAllRowsExpandIcon,
 *    collapseAllIcon: this.myAllRowsCollapseIcon,
 * {{'}'}}</pre>
 */
properties: DatatableRowsExpanderModel;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Main container
 *  container: {{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // Expanding icon styling
 *  expandAllIcon: IconStylingModel, //refer to icon component
 *  // Collapsing icon styling
 *  collapseAllIcon: IconStylingModel, //refer to icon component
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 *  new DatatableRowsExpanderStylingModel({{'{'}}
 *    container: {{'{'}}class: 'my-datatable-rows-expander'{{'}'}},
 *    expandAllIcon: new IconStylingModel({{'{'}} icon: {{'{'}}themeColor: "primary", class: "rotated"{{'}'}} {{'}'}}),
 *    collapseAllIcon: new IconStylingModel({{'{'}} icon: {{'{'}}themeColor: "primary", class: "rotated"{{'}'}} {{'}'}}),
 *  })
 * </pre>
 */
styling: DatatableRowsExpanderStylingModel;
/**
 * CfIcon component for expanding icon
 * @param {?} value
 * @return {?}
 */
set expandAllIcon(value: IconModel) { this.properties.expandAllIcon = value; }
/**
 * CfIcon component for collapsing icon
 * @param {?} value
 * @return {?}
 */
set collapseAllIcon(value: IconModel) { this.properties.collapseAllIcon = value; }
/**
 * @hidden 
 * Emit events on icons clicks: expand or collapse
 */
onToggle = new EventEmitter();
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new DatatableRowsExpanderModel();
    this.styling = new DatatableRowsExpanderStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('datatable-rows-expander', DatatableRowsExpanderTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'DATATABLE-ROWS-EXPANDER').then(sampler => {
        // console.log('DATATABLE-ROWS-EXPANDER', this);
      });
    });
  }
/**
 * @hidden 
 * Function to run event emiter and send toggle type
 * @param {?} type
 * @return {?}
 */
toggle(type) { this.onToggle.emit(type); }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-datatable-rows-expander',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-datatable-rows-expander'\"> <cf-icon (click)=\"toggle('expand')\" [properties]=\"properties?.expandAllIcon\" [styling]=\"styling?.expandAllIcon\"></cf-icon> <cf-icon (click)=\"toggle('collapse')\" [properties]=\"properties?.collapseAllIcon\" [styling]=\"styling?.collapseAllIcon\"></cf-icon> </div>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'expandAllIcon': [{ type: Input, args: ['expandAllIcon', ] },],
'collapseAllIcon': [{ type: Input, args: ['collapseAllIcon', ] },],
'onToggle': [{ type: Output },],
};
}

function CfDatatableRowsExpanderComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfDatatableRowsExpanderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDatatableRowsExpanderComponent.ctorParameters;
/** @type {?} */
CfDatatableRowsExpanderComponent.propDecorators;
/**
 * <pre>{{'{'}}
 *  expandAllIcon: IconModel,
 *  collapseAllIcon: IconModel,
 * {{'}'}}</pre>
 * <h4>expandAllIcon: IconModel</h4>
 * CfIcon component for the main expanding icon.
 * <h4>collapseAllIcon: IconModel</h4>
 * CfIcon component for the main collapsing icon.
 * <p>Example:</p>
 * <pre>{{'{'}}
 *    expandAllIcon: this.myAllRowsExpandIcon,
 *    collapseAllIcon: this.myAllRowsCollapseIcon,
 * {{'}'}}</pre>
 * @type {?}
 */
CfDatatableRowsExpanderComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Main container
 *  container: {{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // Expanding icon styling
 *  expandAllIcon: IconStylingModel, //refer to icon component
 *  // Collapsing icon styling
 *  collapseAllIcon: IconStylingModel, //refer to icon component
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 *  new DatatableRowsExpanderStylingModel({{'{'}}
 *    container: {{'{'}}class: 'my-datatable-rows-expander'{{'}'}},
 *    expandAllIcon: new IconStylingModel({{'{'}} icon: {{'{'}}themeColor: "primary", class: "rotated"{{'}'}} {{'}'}}),
 *    collapseAllIcon: new IconStylingModel({{'{'}} icon: {{'{'}}themeColor: "primary", class: "rotated"{{'}'}} {{'}'}}),
 *  })
 * </pre>
 * @type {?}
 */
CfDatatableRowsExpanderComponent.prototype.styling;
/**
 * @hidden 
 * Emit events on icons clicks: expand or collapse
 * @type {?}
 */
CfDatatableRowsExpanderComponent.prototype.onToggle;
/** @type {?} */
CfDatatableRowsExpanderComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
